import {
  BurnRequest as BurnRequest2Step,
  ExecutedBurn as ExecutedBurn2Step,
  RejectedBurn as RejectedBurns2Step,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import {
  BurnRequest as BurnRequest3Step,
  FailedBurn as FailedBurn3Step,
  RejectedBurn as RejectedBurn3Step,
  ExecutedBurn as ExecutedBurn3Step,
} from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Burn';
import { RequestState, RequestType, RowNew } from '../components/Table/types';
import TemplateContract from './TemplateContract';

export type BurnTemplateUnion =
  | TemplateContract<BurnRequest2Step>
  | TemplateContract<ExecutedBurn2Step>
  | TemplateContract<RejectedBurns2Step>
  | TemplateContract<BurnRequest3Step>
  | TemplateContract<FailedBurn3Step>
  | TemplateContract<RejectedBurn3Step>
  | TemplateContract<ExecutedBurn3Step>;

const burnMapper = (
  contract: BurnTemplateUnion,
  requestType: RequestType,
  requestState: RequestState,
  isThreeStep?: boolean,
): RowNew => {
  const commonFields = {
    contractId: contract.contractId,
    createdAt: contract.createdAt,
    amount: contract.payload.burn.amount,
    holder: contract.payload.burn.holder,
    reference: contract.payload.burn.reference,
    sender: contract.payload.burn.holder,
    requestType,
    requestState,
    isThreeStep,
  };
  const flattened: RowNew = {
    ...commonFields,
    receiver: '',
    reason: '',
    operator: '',
    provider: '',
    instrumentId: '',
    registrar: '',
  };

  if ('operator' in contract.payload.burn) {
    flattened.operator = contract.payload.burn.operator;
  }
  if ('operator' in contract.payload) {
    flattened.operator = contract.payload.operator;
  }
  if ('provider' in contract.payload.burn) {
    flattened.provider = contract.payload.burn.provider;
  }
  if ('provider' in contract.payload) {
    flattened.provider = contract.payload.provider;
  }

  if ('reason' in contract) {
    flattened.reason = contract.reason as string;
  }
  if ('reason' in contract.payload) {
    flattened.reason = contract.payload.reason;
  }
  if ('instrumentId' in contract.payload.burn) {
    flattened.instrumentId = contract.payload.burn.instrumentId.id;
    flattened.registrar = contract.payload.burn.instrumentId.admin;
    flattened.receiver = contract.payload.burn.instrumentId.admin;
  }
  if ('instrumentIdentifier' in contract.payload.burn) {
    flattened.instrumentId = contract.payload.burn.instrumentIdentifier.id;
    flattened.registrar = contract.payload.burn.instrumentIdentifier.source;
    flattened.receiver = contract.payload.burn.instrumentIdentifier.source;
  }

  return flattened;
};

export const flattenBurns = (
  contracts: BurnTemplateUnion[],
  requestState: RequestState,
  isThreeStep: boolean,
) => {
  return contracts.map((c) => burnMapper(c, RequestType.Burn, requestState, isThreeStep));
};
